const OFFLINE_PATHS = [
  '/app/report',
  '/app/report/contacts',
  '/app/business-card'
];

export function isOfflinePath(path: string): boolean {
  return OFFLINE_PATHS.includes(path);
}
